export const AppRoutes = {
  ABOUT: () => `/app/about`,
  AUTH: () => `/auth`,
  EMAIL_LINK: () => `/auth/email-link`,
  HOME: () => `/app/home`,
  LANGUAGE: (lang: string) => `/${lang}`,
  LIBRARY: () => `/app/library`,
  PEEK: (storyId: string) => `/peek/app/stories/${storyId}`,
  PRIVACY: () => `/privacy`,
  ROOT: () => `/`,
  SETTINGS: () => `/app/settings`,
  SIGN_IN: () => `/sign-in`,
  SIGN_UP: () => `/sign-up`,
  STORIES: () => `/app/stories`,
  STORY: (storyId: string) => `/app/stories/${storyId}`,
  TERMS: () => `/terms`,
};
